// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import Lightbox from 'vue-easy-lightbox'
import i18n from './lang/lang';


Vue.use(Lightbox)

import {
    FontAwesomeIcon
} from "@fortawesome/vue-fontawesome";

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false
/* eslint-disable no-new */
new Vue({
    el: '#app',
    i18n,
    router,
    store,
    components: {
        App
    },
    template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js